// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common-dialog[data-v-2b507f26]{.el-dialog__body{padding:0 20px}}.add-team-dialog-form .el-form-item[data-v-2b507f26]{width:100%}[data-v-2b507f26] .add-team-dialog-form .el-form-item__content{width:300px}", ""]);
// Exports
module.exports = exports;
